module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0109.jpg?v=f60d3267";